import React from 'react';
import { createIcon } from '@chakra-ui/icon';
export default createIcon({
    displayName: 'CheckIcon',
    path: (React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M20.879 4.837L8.547 17.17l-5.365-5.366a1 1 0 10-1.414 1.415L7.84 19.29a.999.999 0 001.414 0L22.293 6.251a.999.999 0 10-1.414-1.414", fill: "currentColor" }))),
});
//# sourceMappingURL=Check.js.map